import { useState, useEffect } from "react";
import API from "../providers/api";
import useLogin from "../providers/use_login";

export default () => {
  const { token, user } = useLogin();
  const [isBusy, setIsBusy] = useState(true);
  const [isBusyTask, setIsBusyTask] = useState(false);
  const [propuestas, setPropuestas] = useState([]);
  const [inactivos, setInactivos] = useState([]);

  const crearHeaders = () => {
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    };
    return config
  }

  useEffect(() => {
    if (!user) return
    const fetchPropuestas = async () => {
      const config = {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      };
      const res = await API.get("admin/data", config);

      setIsBusy(false);
      setPropuestas(res.data.propuestas || [])
      setInactivos(res.data.inactivos || [])
    };

    if (!token) return;
    fetchPropuestas();
  }, [token, user]);

  const aprobarUsuario = async id => {
    setIsBusyTask(true)
    const config = crearHeaders()
    let res
    try {
      res = await API.put("admin/activarusuario/" + id, {}, config);
    } catch (err) {
      console.error(err)
      return false
    }

    setIsBusyTask(false);

    if (res?.status === 204) {
      return true
    } else return false
  }

  const borrarUsuario = async id => {
    setIsBusyTask(true)
    const config = crearHeaders()
    let res
    try {
      res = await API.delete("admin/borrarusuario/" + id, config);
    } catch (err) {
      console.error(err)
      return false
    }

    setIsBusyTask(false);

    if (res?.status === 204) {
      return true
    } else return false
  }

  const reFetch = async () => {
    setIsBusy(true);
    const config = crearHeaders()
    const res = await API.get("admin/data", config);

    setIsBusy(false);
    setPropuestas(res.data.propuestas || [])
    setInactivos(res.data.inactivos || [])
  };

  return { propuestas, reFetch, isBusy, isBusyTask, inactivos, aprobarUsuario, borrarUsuario };
};
